import { Controller } from "@hotwired/stimulus"

const DEBOUNCE_MS = 400

// Aperçu d'un email en direct : à chaque saisie (debounce), le formulaire est soumis vers l'action
// d'aperçu par un bouton caché (formaction, data-turbo-frame), et la Turbo Frame de l'aperçu se
// remplit du rendu serveur. `formnovalidate` : un champ obligatoire encore vide ne bloque pas l'aperçu.
export default class extends Controller {
  static targets = ["submit"]
  static values = { auto: { type: Boolean, default: true } }

  connect() {
    if (this.autoValue) this.refresh()
  }

  disconnect() { clearTimeout(this.timer) }

  // Aperçu demandé par un bouton (panneau de la fiche) : on l'amène à l'écran une fois chargé.
  reveal(event) {
    event.target.scrollIntoView({ block: "start", behavior: "smooth" })
  }

  // Enregistrement ou envoi : plus d'aperçu en attente (il partirait pendant la navigation).
  submitted(event) {
    if (event.submitter && event.submitter === this.submitTarget) return
    clearTimeout(this.timer)
    this.stopped = true
  }

  schedule() {
    if (this.stopped) return
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.refresh(), DEBOUNCE_MS)
  }

  refresh() {
    clearTimeout(this.timer)
    if (this.hasSubmitTarget && this.submitTarget.isConnected) this.submitTarget.click()
  }
}
